define('core/constants/exploreModuleConstants',[
    'core/strings',
], function (
    strings
) {
    'use strict';

    var gettext = strings.get;

    return {
        TABS: {
            TOP: {
                id: 'top',
                name: gettext('Trending'),
                fetchName: 'trending',
            },
            POPULAR: {
                id: 'popular',
                name: gettext('Popular'),
                fetchName: 'popular',
            },
            RECENT: {
                id: 'recent',
                name: gettext('Newest'),
                fetchName: 'new',
            },
            DISCUSSIONS: {
                id: 'discussions',
                name: gettext('Discussions'),
            },
        },
    };
});

